import { Vector2 } from '@math.gl/core';
import { CrossSectionCanvas } from '@pages/cross-section/shared/CrossSectionCanvas';
import Konva from 'konva';

function drawPoint(opts: {
    id: string;
    point: Vector2;
    color: number[];
    visible: boolean;
    filename: string;
    csCanvas: CrossSectionCanvas;
    onClickCallback: (point: ICrossSectionVertex, x: number, y: number) => void;
}) {
    const { id, point, color, filename, csCanvas } = opts;

    let visible = opts.visible;

    const x = csCanvas.metersToScreenCoordsX(point[0]);
    const y = csCanvas.metersToScreenCoordsY(point[1]);
    const r = 3;
    const y_offset = 0;

    if (x > csCanvas.width - csCanvas.canvasOptions.side_margin / 2 || x < csCanvas.canvasOptions.side_margin / 2) {
        visible = false;
    }
    if (y < csCanvas.canvasOptions.top_margin || y > csCanvas.height - csCanvas.canvasOptions.bottom_margin) {
        visible = false;
    }

    const colorString: string = 'rgb(' + color.join(',') + ')';

    const pointCircle = new Konva.Circle({
        visible: visible,
        name: 'pointcloud_' + id,
        x: x,
        y: y - r + y_offset,
        stroke: 'rgb(0,0,0)', //colorString,
        fill: colorString,
        strokeWidth: 0.5,
        radius: r,
    });

    pointCircle.on('click tap', () => {
        //onClickCallback(pointCircle, x, y);
        //showTooltip(pointCircle, x, y, r, y_offset, true, csCanvas);
    });

    pointCircle.on('mouseover', function () {
        showTooltip(filename, x, y, r, y_offset, false, csCanvas);
    });

    pointCircle.on('mouseout', csCanvas.clearHoverTooltips);

    csCanvas.contentLayer.add(pointCircle);

    return [pointCircle];
}

const showTooltip = (filename: string, x: number, y: number, r: number, y_offset: number, showProps: boolean, csCanvas: CrossSectionCanvas) => {
    const size = r * 2 + 4;
    const t: string[] = [filename].filter(Boolean);

    const bbRect = new Konva.Rect({
        x: x - (size - 1) / 2,
        y: y - (size - 1) / 2 - r + y_offset,
        width: size,
        height: size,
        stroke: 'gray',
        strokeWidth: 1,
        listening: false,
    });

    csCanvas.tooltipLayer.add(bbRect);
    csCanvas.drawTooltip(x, y - 4 - r * 2 + y_offset - 10, t.join('\n'), !!showProps);
    csCanvas.drawSnapCursor(true, x, y - r + y_offset);
};

export const CrossSectionPoint = {
    drawPoint,
};
